var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "table-style table-style--default"
  }, [_c('myinfo-modify-row', {
    attrs: {
      "pointer": "",
      "label": "First Name"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-600px",
    attrs: {
      "type": "text",
      "placeholder": "Please enter your first name",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "firstName", $$v);
      },
      expression: "form.meta.firstName"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "pointer": "",
      "label": "Last Name"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 mw-lg-600px",
    attrs: {
      "type": "text",
      "placeholder": "Please enter your last name",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "lastName", $$v);
      },
      expression: "form.meta.lastName"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "pointer": "",
      "label": "E-mail"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "name": "email1",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.email1,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "email1", $$v);
      },
      expression: "form.meta.email1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("@")]), _c('v-col', [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "name": "email2",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.email2,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "email2", $$v);
      },
      expression: "form.meta.email2"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-select', {
    staticClass: "w-100 mw-sm-320px",
    attrs: {
      "items": [{
        text: 'Please type your E-mail directly',
        value: null
      }, 'gmail.com', 'naver.com', 'daum.net'],
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "change": function change($event) {
        _vm.form.meta.email2 = _vm.form.meta.email3;
      }
    },
    model: {
      value: _vm.form.meta.email3,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "email3", $$v);
      },
      expression: "form.meta.email3"
    }
  })], 1)], 1)], 1), _c('myinfo-modify-row', {
    attrs: {
      "pointer": "",
      "label": "Phone"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "placeholder": "Please enter your phone number",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "phone", $$v);
      },
      expression: "form.meta.phone"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "pointer": "",
      "label": "Type of inquiry"
    }
  }, [_c('v-select', {
    staticClass: "w-100 mw-lg-600px",
    attrs: {
      "items": _vm.inquiryItems,
      "type": "text",
      "placeholder": "Please select Type of inquiry",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.inquiry,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "inquiry", $$v);
      },
      expression: "form.meta.inquiry"
    }
  })], 1), _c('myinfo-modify-row', {
    attrs: {
      "pointer": "",
      "label": "Message"
    }
  }, [_c('v-textarea', {
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "placeholder": "Please enter a message",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.form.meta.message,
      callback: function callback($$v) {
        _vm.$set(_vm.form.meta, "message", $$v);
      },
      expression: "form.meta.message"
    }
  })], 1)], 1), _c('div', {
    staticClass: "mt-30 mt-md-60 mt-lg-90 text-center"
  }, [_c('v-btn', {
    staticClass: "w-100 mw-240px font-weight-bold",
    attrs: {
      "x-large": "",
      "tile": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('save');
      }
    }
  }, [_vm._v("Send")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }